import Paper from '@material-ui/core/Paper';
import React from 'react';
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContentWrapper from '../../components/messages/customSnack';
const apiBaseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3000";

const styles = theme => ({
  root:{
    marginTop:"10%"
  },
  background:{
    //backgroundColor: "grey"
  },
  paper: theme.mixins.gutters({
    paddingTop: 50,
    paddingBottom: 50,
    marginTop: theme.spacing.unit * 3,
  }),
  container: {
   display: 'flex',
   flexWrap: 'wrap',
 },
 textField: {
   marginLeft: theme.spacing.unit,
   marginRight: theme.spacing.unit,
 },
 button: {
   //width:00,
    margin: theme.spacing.unit,
  },
  bigAvatar: {
  width: 75,
  height: 75,
   backgroundColor: "#fff"
  },
 menu: {
   width: 100,
 },
 logo:{
 maxWidth: "60px",
 maxHeight: "60px",
}
});


class PasswordSet extends React.Component {
  constructor(props){
    super(props);
    this.state={
      username:'test',
      password:'',
      consfirm_password:'',
      messageError:'',
      usernameMessage:'Enter your username',
      passwordMessage:'Enter your password',
      usernameInvalid: false,
      passwordInvalid: false
    }
  }

  componentDidMount(){

  }

  handleChange = name => event => {
   this.setState({
     [name]: event.target.value,
   });
 };

 handleSnackClose = (event, reason) => {
   if (reason === 'clickaway') {
     return;
   }
   this.setState({ snackOpen: false });
 };

 handleClick(event){
   var self = this;

   var payload = {
     password: this.state.password,
     token: self.props.match.params.token
   }

   if (self.state.password !== self.state.confirm_password) {
     self.setState({
       snackOpen: true,
       snackVariant:"error",
       snackMessage:"Whoops! Your passwords don't match."
     });
   }else{
     axios.put(`${apiBaseUrl}/v1/user/password/reset`, payload)
     .then(function (response) {

       if(response.status === 200){
          console.log("success", response)
         self.setState({
           snackOpen: true,
           snackVariant:"success",
           snackMessage:"Your password has been reset. Please login with your new password."
         });
         setTimeout(function(){
           let path = `/${self.props.match.params.org}/login`
           self.props.history.push(path);
         }, 1000);
       }
     })
     .catch(function (error) {
       console.log("error", error);
       self.setState({
         snackOpen: true,
         snackVariant:"error",
         snackMessage:"Your token was invalid or expired."
       });
     });
   }
 }

  render() {
    const { classes } = this.props;
    return (
    <div className={classes.background}>
    <Grid container className={classes.root} justify={"center"}>

      <Paper className={classes.paper} elevation={4}>
      <Grid container justify={"center"}>
      <Avatar aria-label="Logo" className={classes.bigAvatar}>
            <img className={classes.logo} alt="logo" src="/images/icon.png" />
      </Avatar>
      </Grid>

      <form className={classes.container} autoComplete="off">
        <TextField
        label="New Password"
        id="margin-none"
        fullWidth
        className={classes.textField}
        helperText="Enter your new password."
        onChange={this.handleChange('password')}
        />

        <TextField
        label="Confirm Password"
        id="margin-none"
        fullWidth
        className={classes.textField}
        helperText="Re-enter your new password."
        onChange={this.handleChange('confirm_password')}
        />

        <Grid container justify={"center"}>
        <br />
        <Button
        variant="contained"
        color="primary"
        fullWidth="true"
        className={classes.button}
        onClick={(event) => this.handleClick(event)}
        >
        Set Password
        </Button>
        </Grid>

        </form>
      </Paper>
    </Grid>
    <Snackbar
       anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'center',
       }}
       open={this.state.snackOpen}
       autoHideDuration={3000}
       onClose={this.handleSnackClose}
       >
         <MySnackbarContentWrapper
         variant={this.state.snackVariant}
         message={this.state.snackMessage}
         onClose={this.handleSnackClose}
        />
    </Snackbar>
    </div>
  );
}
}



/*PaperSheet.propTypes = {
  classes: PropTypes.object.isRequired,
};*/

export default withStyles(styles)(PasswordSet);
